import React from "react";

import i18next from "i18next";
import { useTranslation } from "react-i18next";

import { useSelector, useDispatch } from "react-redux";

import { Grid, Typography, Avatar, IconButton } from "@mui/material";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";

import TabContext from "@mui/lab/TabContext";
import TabPanel from "@mui/lab/TabPanel";

import AdminSideNavbar from "./AdminSideNavbar";
import Header from "../Header";
import Organizations from "./Organizations";
import { ComponentType } from "../../common/enum";
import { adminViewStyle } from "./styles";
import { adminDashboardMenu } from "../../data";

import Snackbar from "../../components/Snackbar";
import { setSnackbarOpen } from "./adminSlice";

const AdminView = () => {
  const [isSidebarOpen, setIsSidebarOpen] = React.useState(true);

  const {
    translate,
    auth: {
      profile: { entity },
    },
    adminDashboard: {
      adminDashboardTab = adminDashboardMenu[0].title,
      snackBarOpen,
      snackBarMessage,
      snackBarSeverity,
    },
  } = useSelector((state) => state);

  const { t } = useTranslation();
  const dispatch = useDispatch();

  React.useEffect(() => {
    i18next.changeLanguage(translate);
  }, [translate]);

  const onClose = React.useCallback(() => {
    dispatch(setSnackbarOpen(false));
  }, [dispatch]);

  const toggleSidebar = () => {
    setIsSidebarOpen((prev) => !prev);
  };

  return (
    <div style={adminViewStyle}>
      <Header t={t} />
      <TabContext
        value={
          adminDashboardTab ? adminDashboardTab : adminDashboardMenu[0].title
        }
        orientation="vertical"
        centered
      >
        <Grid container sx={{justifyContent: "flex-start" }}>
          {/* Sidebar */}
          <Grid
            item
            xs={isSidebarOpen ? 3 : 0} // Ajusta o tamanho baseado no estado
            sx={{
              transition: "width 0.3s ease",
              display: "flex",
              flexDirection: "column",
              borderRight: "1px solid #ccc",
              minHeight: "100vh",
              padding: "20px 8px 7px 31px"
            }}
          >
            <Grid
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
               // padding: "10px",
              //  backgroundColor: "#f4f4f4",
              }}
            >
              {isSidebarOpen && (
                <Grid sx={{ display: "flex", alignItems: "center", marginBottom:"15px"}}>
                  <Avatar
                    alt={`Entidade ${entity?.entityName}`}
                    src="https://play-lh.googleusercontent.com/1keEOkk2GrxZpaRH73-vDqpAXhJNU9tbP5mfk82X6YxH8EhnU2JPOb5w1FLUJiqkEg"
                    sx={{ width: 55, height: 55 }}
                  />
                  <Typography sx={{ }}>
                    <span>{t("hello")},</span>{" "}
                    <span
                      style={{
                        display: "block",
                        fontWeight: "bold",
                        fontSize: "28px",
                      }}
                    >
                      {entity?.entityName}
                    </span>
                  </Typography>
                </Grid>
              )}
              <IconButton onClick={toggleSidebar}>
                {isSidebarOpen ? <ChevronLeft /> : <ChevronRight />}
              </IconButton>
            </Grid>
            {isSidebarOpen && (
              <AdminSideNavbar t={t} component={ComponentType.ADMIN_VIEW} />
            )}
          </Grid>

          {/* Main Content */}
          <Grid item xs={isSidebarOpen ? 9 : 11} >
            <TabPanel value={adminDashboardMenu[0].title}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={12}>
                  <h1 style={{ marginBottom: "15px", fontSize: "32px" }}>
                    {t("organizations")}
                  </h1>
                  <Organizations t={t} />
                </Grid>
              </Grid>
            </TabPanel>
          </Grid>
        </Grid>
      </TabContext>
      <Snackbar
        open={snackBarOpen}
        severity={snackBarSeverity}
        onClose={onClose}
        message={snackBarMessage}
        t={t}
      />
    </div>
  );
};

export default AdminView;
